<template>
    <admin-layout :show-sidebar="false" mainPage="project">

<!--        <template #toolbox>-->
<!--            <learning-path-toolbox :learning-path="lp"/>-->
<!--        </template>-->

        <app-content-pane class="ml-3" v-if="is_ready">
            <template #title>

                <heading :project="project"
                         :path="project.learning_path"
                         :tenants="tenants"
                         page="path"
                         class="mb-3" />

                <hr class="mb-0">
                <div class="actions px-4">

                    <div class="info">
                        <dl class="theme">
                            <dt>Goal</dt>
                            <dd>{{ theme.name }}</dd>
                        </dl>
                        <dl class="path">
                            <dt>Learning Path</dt>
                            <dd>{{ project.learning_path.name }}</dd>
                        </dl>
                    </div>
                </div>

                <hr class="my-0">

            </template>

            <section v-if="project.teams.length"
                     ref="content"
                     class="pb-3 progress-details">

                <div class="controls">
                    <a href="#" @click.prevent="scrollLeft()" class="left">
                        <icon-chevron-left size="20" color="dark"/>
                    </a>
                    <a href="#" @click.prevent="scrollRight()" class="right">
                        <icon-chevron-right size="20" color="dark"/>
                    </a>
                </div>

                <div class="teams sec-row">
                    <div class="sec-content">
                        <div class="sec-col" v-for="team in project.teams">
                            <team-card :team="team" :canvas="project.canvases.find(c => c.team_id === team.id)"/>
                        </div>
                        <div class="sec-col mini"></div>
                    </div>
                </div>

                <div v-for="stage in _$$path['stages']" :key="stage">
                    <div :style="{backgroundColor: _$$path[`stage_${stage}_config`].color}"
                         class="stage-name">
                        {{ _$$path[`stage_${stage}_config`].name }}
                    </div>
                    <div v-for="section in _$$path[`stage_${stage}_activity_sections`]" class="sec-row">
                        <div class="sec-info">
                            <strong>{{ section.name }}</strong>
                            <p>{{ section.description }}</p>
                        </div>
                        <div class="sec-content">
                            <div class="sec-col" v-for="team in project.teams" :key="team">
                                <div class="mb-1" v-for="item in canvasElements(team, stage, section)" :key="item.id">
                                    <canvas-element :item="item"/>
                                </div>
                            </div>
                            <div class="sec-col mini"></div>
                        </div>
                    </div>
                </div>

            </section>
            <section class="py-5 px-5" v-else>
                <div class="alert alert-warning mb-0">
                    This project have no teams yet. Create teams first to check their progress.
                </div>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import LearningPathToolbox from "@/Components/Toolbox/LearningPathToolbox";
import TeamCard from "@/Components/Team/TeamCard";
import CanvasElement from "@/Pages/Project/CanvasElement";
import Heading from "@/Components/Project/Heading";
import API from "@/API";
import {mapActions} from "vuex";
import themes from "@/DATA/themes";
import {findModel} from "@/DATA/functions";
import utils from "@/mixins/utils";
import IconChevronLeft from "@/Icons/IconChevronLeft";
import IconChevronRight from "@/Icons/IconChevronRight";
import jQuery from "jquery";


export default {
    name: "Show",
    components: {
        IconChevronRight,
        IconChevronLeft, AdminLayout, AppContentPane, TeamCard, CanvasElement, LearningPathToolbox, Heading},
    mixins: [utils],

    props: ['project', 'tenants'],


    data(){
        return {

            is_ready: false,
            rows: [],
            row_infos: [],

            users: [],
            elements: [],

            repos: {
                path: {
                    scope: {name: API.fragments.SCOPE_LEARNING_PATH, id: this.project.learning_path.id},
                    storage: null,
                },
            },

            canvases: {},
        }
    },

    computed: {

        _$$path(){
            return this.repos.path.storage;
        },

        theme(){
            return themes.reduce((prev, val) => val.id == this.project.theme ? val : prev, {id: 0, name: 'Unknown', slug: 'unknown'});
        },

        activities(){
            return this.elements.filter(e => e.type === 'activity');
        }

    },


    methods: {

        ...mapActions('repositories', {
            repo: 'getRepository',
            freeRepo: 'freeRepository',
            updateRepo: 'updateRepository',
        }),

        getRows(){
            return document.getElementsByClassName('sec-row')
        },

        getRowInfos(){
            return document.getElementsByClassName('sec-info')
        },

        scrollLeft(){
            const $head = jQuery('.teams.sec-row');
            $head.animate({scrollLeft: $head.scrollLeft() - 300}, 300);
        },

        scrollRight(){
            const $head = jQuery('.teams.sec-row');
            $head.animate({scrollLeft: $head.scrollLeft() + 300}, 300);
        },

        winScroll(){
            const $win = jQuery(window);
            const $controls = jQuery('.controls .left, .controls .right');
            const scroll = $win.scrollTop();

            if( scroll > 203 ){
                $controls.css({top: scroll - 203});
            }else{
                $controls.css({top: 0});
            }
        },

        syncScroll(ev){
            const x = ev.target.scrollLeft;
            this.rows.forEach(el => {
                if( el !== ev.target ){
                    el.scrollLeft = x;
                }
            });
            this.row_infos.forEach(el => {
                el.style.left = x + 'px';
            });
        },

        scrollHorizontal(ev){
            ev.stopPropagation();
            const $head = jQuery('.teams.sec-row');
            const $target = $(ev.currentTarget);

            if( $target.hasClass('teams') ){
                ev.preventDefault();
                $head.scrollLeft($head.scrollLeft() + ev.originalEvent.deltaY + ev.originalEvent.deltaX);
            }else{
                $head.scrollLeft($head.scrollLeft() + ev.originalEvent.deltaX);
            }
        },

        resize(){
            this.rows.forEach( el => el.style.width = 0 );
            setTimeout( () => this.rows.forEach( el => el.style.width = (this.$refs.content.offsetWidth) + 'px' ), 10 );
        },

        async initRepos(){
            for( const key in this.repos ){
                if( !this.repos.hasOwnProperty( key ) ) continue;
                this.repos[key].storage = (await this.repo(this.repos[key].scope)).fragments;
            }
        },

        async initCanvasRepos(){
            for( const key in this.project.canvases ){
                if( !this.project.canvases.hasOwnProperty( key ) ) continue;
                const canvas = this.project.canvases[ key ];
                const team = findModel( this.project.teams, canvas.team_id );
                if( !team ) continue;

                this.canvases[ team.id ] = {
                    canvas_id: canvas.id,
                    elements: (await this.repo({
                        name: API.fragments.SCOPE_CANVAS,
                        id: canvas.id
                    })).fragments
                };
            }
        },

        async loadElements(){
            let element_ids = [];
            if( !this._$$path.stages ) return;

            for( const i in this._$$path.stages ){
                const stage = this._$$path.stages[ i ];

                const sections = this._$$path[`stage_${stage}_activity_sections`];
                if( !sections ) continue;

                for(const j in sections){
                    const elements = this._$$path[`stage_${stage}_combined_activities_${sections[j].id}`];
                    if( !elements ) continue;
                    element_ids = element_ids.concat( elements.map(e => e.v) );
                }
            }

            this.elements = (await API.elements.bulk({ids: element_ids}));

        },

        /**
         * Get the structure of the canvas element.
         * @param {Object} team
         * @param {string} stage
         * @param {Object} section
         */
        canvasElements(team, stage, section){

            const team_canvas = this.canvases[ team.id ];
            const path_elements = this._$$path[ `stage_${stage}_combined_activities_${section.id}` ]

            const canvas_uploads = typeof team_canvas.elements[`canvas_upload_${stage}_${section.id}`] !== 'undefined' ? team_canvas.elements[`canvas_upload_${stage}_${section.id}`] : [];
            const elements = [];

            for ( const i in path_elements ){
                const path_element_id = path_elements[i].id;
                const element_id = path_elements[i].v;

                const element = this.activities.find(a => a.id === element_id);
                if( !element ) continue;

                elements.push({
                    id: this.utils.randomId({prefix: 't'}),
                    path_element_id,
                    element_id,
                    element,
                    canvas_data: {
                        uploads: canvas_uploads.filter(u => u.activity_id === path_element_id),
                    }
                });
            }

            const custom_uploads = canvas_uploads.filter(u => !u.activity_id);

            if( custom_uploads.length ){
                elements.push({
                    id: this.utils.randomId({prefix: 't'}),
                    path_element_id: null,
                    element_id: null,
                    element: null,
                    canvas_data: {
                        uploads: canvas_uploads.filter(u => !u.activity_id),
                    },
                });
            }


            return elements;
        },

        getStatus(element, team, stage, section){
            console.log({element, team, stage, section})
        }

    },


    async mounted() {
        await this.initRepos();
        await this.initCanvasRepos();
        await this.loadElements();
        this.is_ready = true;

        this.resize();
        window.onresize = this.resize;

        this.$nextTick(() => {

            this.rows       = this.getRows();
            this.row_infos  = this.getRowInfos();

            if( this.rows.length ){
                this.rows[0].addEventListener('scroll', this.syncScroll);
                jQuery('.sec-row').on('wheel', this.scrollHorizontal);
                // this.rows[0].onwheel = this.scrollHorizontal;
            }

            jQuery(window).on('scroll', this.winScroll);

        });


        this.setTitle( `${this.project.name} - Progress` );

    },

    beforeUnmount() {

        if( this.rows.length ){
            this.rows[0].removeEventListener('scroll', this.syncScroll);
        }

        jQuery('.progress-details').off('wheel', this.scrollHorizontal);
        jQuery(window).off('scroll', this.winScroll);
        window.onresize = null;
    }

}
</script>

<style lang="scss" scoped>
.actions{
    display: flex;
    align-items: center;
}
.info{
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @include media-breakpoint-up(md) {
        flex-direction: row;
    }

    > * {
        padding: 0.8rem 1.2rem;
        flex: 0 0 50%;
    }

    .theme{
        border-bottom: $light-borders solid 1px;
        flex: 0 0 420px;

        @include media-breakpoint-up(md) {
            border-bottom: none;
            border-right: $light-borders solid 1px;
        }
    }

    .path{
        border-bottom: $light-borders solid 1px;
        flex: 0 0 300px;

        @include media-breakpoint-up(md) {
            border-bottom: none;
            border-right: $light-borders solid 1px;
        }
    }

    dl, dd{
        margin-bottom: 0;
    }
}

$info-width: 200px;
$col-width: 280px;
$section-width: 0;
$section-min-height: 180px;

.sec-row{
    display: flex;
    position: relative;
    width: $section-width;
    overflow: hidden;
    border-bottom: $light-borders dotted 1px;
    background-color: white;

    &.teams{
        position: sticky;
        top: 50px;
        background: white;
        z-index: 10;
        overflow: auto;

        .sec-info, .sec-content{
            min-height: 0;
        }
    }

    &:hover{
        .sec-info, .sec-content{
            background-color: darken($light, 0.5%);
        }
    }
}

.sec-info{
    position: absolute;
    width: $info-width;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 5;
    background: white;
    padding: 1rem 0.8rem 1rem 2rem;
    min-height: $section-min-height;
    box-shadow: rgba($dark, 0.1) 5px 0 5px;
}

.sec-content{
    margin-left: $info-width;
    display: flex;
    min-height: $section-min-height;
}

.sec-col{
    width: $col-width;
    flex: 0 0 $col-width;
    border-right: $light-borders dotted 1px;
    padding: 1rem;

    &.mini{
        width: 3rem;
        flex: 0 0 3rem;
    }
}

.stage-name{
    padding: 1rem 2rem;
    color: white;
    font-weight: $font-weight-bold;
    font-size: 24px;
}

.controls{
    position: relative;
    z-index: 12;

    .left, .right{
        position: absolute;
        top: 0;
        width: 3rem;
        height: 10.78rem;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(white, 0.7);
        font-weight: $font-weight-bold;
        border-radius: 0 .3rem .3rem 0;
        backdrop-filter: blur(5px);
        border: $light-borders solid 1px;
    }

    .left{
        left: 0;
    }
    .right{
        right: 0;
    }
}

.progress-details{
    position: relative;
}

</style>
